import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ISimpleResponse } from '../../interfaces/response/ISimpleResponse';

@Injectable({
    providedIn: 'root'
})
export class DescuentosService {

    baseUrl = `${environment.baseUrl}`;
    apiUrl = `${environment.ApiPricing}`;
    url: string;

    constructor(private http: HttpClient) {
        this.url = this.baseUrl + this.apiUrl;
    }

    totalDescuento(numberObjects: number): Observable<number> {
      return this.http.get<ISimpleResponse<number>>(`${this.baseUrl}${this.apiUrl}/GetTotalDiscount/${numberObjects}`).pipe(
            map(resp => resp.data)
        );
    }

    primaMinima(idCotizacion: number): Observable<any> {
      return this.http.get<any>(`${this.url}/GetMinimumPremium/${idCotizacion}`);
    }

    /**
    * Check if the product is deprecated in a date
    * @param idProduct The product ID
    * @param date The date when the product purchase
    * @param precio The product price
    * @param idObjeto The product IdObjeto
    * @returns The product deprecation response from API Pricing
    */
    productDepreciation(idProduct: number, date: string, value: number, idObjeto: number) {
      return this.http.get<ISimpleResponse<number>>(`${this.url}/GetProductDepreciation/${idProduct}/${date}/${value}/${idObjeto}`).pipe(
            map(resp => resp.data)
        );
    }
}
